export default __webpack_public_path__ + "static/media/logo-masorden-blanco-small.5a0786d7.svg";